<template>
  <div id="categories">
    <CategorySelector :list="event.categories"></CategorySelector>

    <template v-if="$route.params.category && groups">
      <GroupSelector :category_id="$route.params.category" :list="groups"></GroupSelector>
    </template>
    <template v-if="$route.params.group">
      <template v-if="type == 0">
        <Standings :table="standing" :group_id="$route.params.group"></Standings>
        <div class="details" @click="expanded_group = !expanded_group">
          {{'miclive.standing.group-details' | translate}}
        </div>
      </template>
      <Matches v-if="expanded_group" :matches="matches"></Matches>
    </template>
  </div>
</template>

<script>
  import CategorySelector from "@/components/domain/categories/Categories";
  import GroupSelector from "@/components/domain/categories/Groups";
  import Standings from "@/components/domain/categories/Standings";
  import Matches from "@/components/domain/categories/Matches";

  export default {
    name: "Calendar",
    components: {
      CategorySelector,
      GroupSelector,
      Standings,
      Matches
    },
    props: {
      type: Number,
    },
    data() {
      return {
        expanded_group: true
      };
    },
    computed: {
      // categories() {
      //   return this.$store.getters["competition/getCategories"];
      // },
      event() {
        return this.$store.getters["competition/getEvent"];
      },
      rounds(){
        return this.$store.getters["competition/getListRounds"]();
      },
      // selectedCategory() {
      //   return this.$store.getters["competition/getSelectedCategory"];
      // },
      groups() {
        return this.$store.getters["competition/getGroupsByCategory"](this.$route.params.category);
      },
      standing() {
        return this.$store.getters["competition/getStandingsByGroup"](this.$route.params.group);
      },
      // $route.params.group() {
      //   return this.$store.getters["competition/get$route.params.group"];
      // },
      // table() {
      //   return this.$store.getters["competition/getTable"];
      // },
      matches() {
        return this.$store.getters["competition/getMatchesByGroup"]( this.$route.params.group );
      }
    },
    watch: {
      // call again the method if the route changes
      $route: "loadInfo"
    },
    methods: {
      loadData: function () {
        var self = this;
        this.$store.dispatch('competition/loadEvent', self.$route.params.idEvent).then(() => {
            self.$store.dispatch('competition/loadFacilities', self.$route.params.idEvent).then(() => {
                self.$store.dispatch('competition/loadGroups', self.$route.params.idEvent).then(() => {
                    self.$store.dispatch('competition/loadRounds', self.$route.params.idEvent).then(() => {
                        self.$store.dispatch('competition/loadMatchesByIdEvent', self.$route.params.idEvent).then(() => {
                            self.$overlay.hide();
                        })
                    })
                })
            })
        })
      },

      loadInfo: function() {
          var self = this
          setTimeout(
              function(){
                  self.$overlay.hide()
              },
              200
          )
      }
    },
    created() {
      this.loadData();
    },
  };

</script>

<style lang="scss" scoped>
  #categories {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;

    .details {
      background: url("/img/down.svg") no-repeat left center;
      background-size: 15px;
      padding-left: 30px;
      cursor: pointer;
      width: fit-content;
      margin: 50px 0;
      text-transform: uppercase;
    }
  }

  @media only screen and (max-width: 600px) {
    #categories {
      .details {
        margin: 20px 0;
      }
    }
  }

</style>
